// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__17p7_","buttons":"RemoveExpirationActionButtons_buttons__3suRP"};